import _ from 'lodash';
import ko from 'rgs-knockout';

export default class AddressEditorModel {
	constructor (options) {
		const optionsInputsDefaults = {
			settlement: {
				disable: undefined,
				showCopy: false,
				nameToCopy: undefined,
			},
			street: {
				disable: undefined,
			},
			house: {
				disable: undefined,
			},
			hasStreets: {
				disable: undefined,
			},
		};

		this._options = options = _.defaultsDeep({}, options, {
			address: undefined,

			datasets: {
				settlements: undefined,
				streetsForSettlement: undefined,
			},
			valueFilters: {
				settlements: undefined,
				streets: undefined,
			},

			disable: undefined,

			inputs: optionsInputsDefaults,

			settlementNameProperty: 'Name', // useful for 'NameRsa', HACKish
		});

		this._address = this._options.address;

		this._optionsInputs = ko.pureComputed(() => {
			return _.defaultsDeep({}, ko.unwrap(this._options.inputs), optionsInputsDefaults);
		});

		this._inputs = {
			settlement: {
				title: 'Город/населенный пункт',
				disable: ko.pureComputed(() => {
					return ko.unwrap(this._options.disable)
						|| ko.unwrap(this._optionsInputs().settlement.disable);
				}),
				showCopy: ko.pureComputed(() => {
					return !this._inputs.settlement.disable()
						&& ko.unwrap(this._optionsInputs().settlement.showCopy);
				}),
				nameToCopy: this._optionsInputs().settlement.nameToCopy,
				copyClick: () => {
					ko.unwrap(this._address).Settlement[this._options.settlementNameProperty](
						ko.unwrap(this._optionsInputs().settlement.nameToCopy));
				},
			},
			street: {
				title: 'Улица',
				disable: ko.pureComputed(() => {
					return ko.unwrap(this._options.disable)
						|| ko.unwrap(this._optionsInputs().street.disable)
						|| !ko.unwrap(ko.unwrap(this._address).HasStreets);
				}),
			},
			house: {
				title: 'Дом',
				disable: ko.pureComputed(() => {
					return ko.unwrap(this._options.disable)
						|| ko.unwrap(this._optionsInputs().house.disable);
				}),
			},
			hasStreets: {
				title: 'Населенный пункт без улиц',
				disable: ko.pureComputed(() => {
					return ko.unwrap(this._options.disable)
						|| ko.unwrap(this._optionsInputs().hasStreets.disable);
				}),
			},
			apartement: {
				title: 'Квартира',
				disable: ko.pureComputed(() => {
					return ko.unwrap(this._options.disable)
						|| ko.unwrap(this._optionsInputs().apartement.disable);
				}),
			},
		};
	}

	dispose () {
		_.each(this._inputs, inputOptions => {
			_.each(inputOptions, opt => {
				if (opt && opt.dispose) {
					opt.dispose();
				}
			});
		});
		this._optionsInputs.dispose();
	}
}
